/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SettingsPage_user_Subscription$ref = any;
export type SettingsPageContainer_SubscriptionQueryVariables = {|
  userId: string
|};
export type SettingsPageContainer_SubscriptionQueryResponse = {|
  +subscriptions: {|
    +$fragmentRefs: SettingsPage_user_Subscription$ref
  |}
|};
export type SettingsPageContainer_SubscriptionQuery = {|
  variables: SettingsPageContainer_SubscriptionQueryVariables,
  response: SettingsPageContainer_SubscriptionQueryResponse,
|};
*/


/*
query SettingsPageContainer_SubscriptionQuery(
  $userId: ID!
) {
  subscriptions(user: $userId) {
    ...SettingsPage_user_Subscription
  }
}

fragment SettingsPage_user_Subscription on SubscriptionNodeConnection {
  edges {
    node {
      id
      name
      source {
        id
        source_icon
      }
      parent {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "user",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsPageContainer_SubscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionNodeConnection",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SettingsPage_user_Subscription"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsPageContainer_SubscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionNodeConnection",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscriptionNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SourceNode",
                    "kind": "LinkedField",
                    "name": "source",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "source_icon",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubscriptionNode",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a57d5d15ca9981a3c41912420a2a91be",
    "id": null,
    "metadata": {},
    "name": "SettingsPageContainer_SubscriptionQuery",
    "operationKind": "query",
    "text": "query SettingsPageContainer_SubscriptionQuery(\n  $userId: ID!\n) {\n  subscriptions(user: $userId) {\n    ...SettingsPage_user_Subscription\n  }\n}\n\nfragment SettingsPage_user_Subscription on SubscriptionNodeConnection {\n  edges {\n    node {\n      id\n      name\n      source {\n        id\n        source_icon\n      }\n      parent {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69b91e72c8eadc8665c359d49334d553';

module.exports = node;
